"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.brandsSubMenu = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
const brandsSubMenu = exports.brandsSubMenu = [{
  path: '/brand/list',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/brand/list.vue'))),
  name: 'Brands',
  meta: {
    title: 'productManagement.brand.title',
    noCache: true,
    hidden: false,
    icon: 'tag'
  }
}, {
  path: '/brand/edit/:id(\\d+)',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/brand/manage.vue'))),
  name: 'productManagement.brand.manage',
  props: {
    isEdit: true
  },
  meta: {
    title: 'productManagement.brand.manage',
    noCache: true,
    activeMenu: '/brand/list',
    hidden: true
  }
}, {
  path: '/brand/add',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/brand/manage.vue'))),
  name: 'productManagement.brand.manage',
  props: {
    isEdit: false
  },
  meta: {
    title: 'productManagement.brand.manage',
    noCache: true,
    activeMenu: '/brand/list',
    hidden: true
  }
}];